/**
 * Initials for the FusionMSI account chip (display name or email).
 */
export function dpUserInitials(user) {
  if (!user) return '';

  const name = String(user.displayName || user.email || '').trim();
  if (!name) return '?';

  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] ?? ''}${parts[parts.length - 1][0] ?? ''}`.toUpperCase();
  }

  const single = parts[0] ?? name;
  if (single.includes('@')) {
    const local = single.split('@')[0] ?? '';
    return local.slice(0, 2).toUpperCase() || '?';
  }

  return single.slice(0, 2).toUpperCase() || '?';
}
